import { productBundleActionTypes } from '@Actions/inventory/productBundleActions';

const ProductBundleReducers = (state = { }, action) => {
  switch (action.type) {
  case productBundleActionTypes.GET_PRODUCT_BUNDLE.LOADING: {
    const { getProductBundleLoading } = action;
    return {
      ...state,
      getProductBundleLoading,
    };
  }
  case productBundleActionTypes.GET_PRODUCT_BUNDLE.SUCCESS: {
    const { bulkPurchaseOrders } = action;
    return {
      ...state,
      bulkPurchaseOrders,
    };
  }
  case productBundleActionTypes.CREATE_PRODUCT_BUNDLE.LOADING: {
    const { createProductBundleLoading } = action;
    return {
      ...state,
      createProductBundleLoading,
    };
  }
  case productBundleActionTypes.UPDATE_PRODUCT_BUNDLE.LOADING: {
    const { updateProductBundleLoading } = action;
    return {
      ...state,
      updateProductBundleLoading,
    };
  }
  case productBundleActionTypes.GET_PRODUCT_BUNDLE_BY_ID.LOADING: {
    const { getProductBundleByIdLoading } = action;
    return {
      ...state,
      getProductBundleByIdLoading,
    };
  }
  case productBundleActionTypes.GET_PRODUCT_BUNDLE_BY_ID.SUCCESS: {
    const { selectedProductBundle } = action;
    return {
      ...state,
      selectedProductBundle,
    };
  }
  default: {
    return state;
  }
  }
};

export default ProductBundleReducers;
